// @flow

import * as React from 'react';
import {useEffect, useRef} from 'react';
import Group from 'sail/Group';
import ContentTabs, {ContentTab} from 'sail/ContentTabs';
import {InfoTooltip} from 'sail/Tooltip';
import {OnlyRenderOnClient} from 'docs/components';
import {useContentGroup} from './ContentGroupContext';

export type TabSize = 'small' | 'medium' | 'large';

type TabSelectorProps = {|
  label?: string,
  size: TabSize,
  tabClassName?: string,
|};

export const TabSelector = ({label, tabClassName, size}: TabSelectorProps) => {
  const {items, onItemSelected, selectedItem} = useContentGroup();
  const ref = useRef();

  useEffect(() => {
    const index = items.findIndex((i) => i.id === selectedItem.id);
    if (ref.current) {
      ref.current.setActiveTab(index === -1 ? 0 : index);
    }
  }, [ref, selectedItem, items]);

  const tabs = items.map((item, i, array) => (
    <ContentTab
      key={item.id}
      posInSet={i + 1}
      setSize={array.length}
      className={tabClassName}
      active={item.id === selectedItem.id}
      onClick={() => onItemSelected(item)}
    >
      <Group
        alignItems="center"
        direction="horizontal"
        spacing={8}
        style={{display: 'inline-flex'}}
      >
        {item.title}
        <OnlyRenderOnClient>
          {item.info ? <InfoTooltip content={item.info} /> : null}
        </OnlyRenderOnClient>
      </Group>
    </ContentTab>
  ));

  return (
    <ContentTabs ref={ref} aria-label={label} size={size}>
      {tabs}
    </ContentTabs>
  );
};
